<template>
    <el-dropdown
        :size="size"
        :hide-on-click="true"
        trigger="click"
        class="base-dropdown-menu"
    >
        <span class="px-1-5 flex-center">
            <i
                :class="menuIcon"
                class="text-secondary-actions hover:text-primary-actions--focus icon-md"
            />
        </span>
        <template #dropdown>
            <el-dropdown-menu class="base-dropdown-menu__menu">
                <slot>
                    <el-dropdown-item
                        v-for="(item, i) in menuItems"
                        :key="i"
                        :class="item.itemClasses"
                        :disabled="item.disabled"
                        class="base-dropdown-menu__item !px-0 !py-0"
                    >
                        <div
                            :class="{ 'opacity-50': item.disabled}"
                            class="flex items-center gap-1.5 w-full px-4 py-2"
                            @click="onClickItem(item)"
                        >
                            <i
                                :class="item.icon"
                                class="text-base"
                            />
                            <span class="text-sm font-medium">{{ item.label }}</span>
                        </div>
                    </el-dropdown-item>
                </slot>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script setup lang="ts">
import { Dropdown as ElDropdown, DropdownItem as ElDropdownItem, DropdownMenu as ElDropdownMenu } from 'element-ui'

interface IDMenuItem {
    icon?: string
    label?: string
    itemClasses?: string
    disabled?: boolean
    callback?: () => void
}

withDefaults(
    defineProps<{
        size?: 'mini' | 'medium' | 'small'
        menuIcon?: string
        menuItems?: Array<IDMenuItem>
    }>(),
    {
        menuIcon: 'vc-icon-menu',
        size: 'mini',
        menuItems: () => []
    }
)

const emit = defineEmits([ 'click-menu' ])

function onClickItem (menu: IDMenuItem) {
    if (menu.disabled) {
        return
    }
    if (menu.callback) {
        menu.callback()
    }
    emit('click-menu', menu)
}
</script>

<style lang="scss">
.el-dropdown-menu.base-dropdown-menu__menu {
    background-color: var(--mainBgColor-color);
    .el-dropdown-menu__item.base-dropdown-menu__item {
        @apply transition;
        background-color: var(--mainBgColor-color);
        &:hover {
            @apply bg-primary-actions-bg--focus;
        }
    }
}
</style>
